function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Label, Action, Streaming, StreamingSituations } from '../commons/IntlMessages';
import { StreamingStatuses } from "../enum/StreamingStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ストリーミング設定モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 変更
   */

  Mode[Mode["Modify"] = 1] = "Modify";
})(Mode || (Mode = {}));
/**
 * 会議ストリーミング設定モーダルコンポーネント
 */


var SessionStreamingSettingModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionStreamingSettingModalComponent, _React$Component);

  var _super = _createSuper(SessionStreamingSettingModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionStreamingSettingModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionStreamingSettingModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Modify:
        _this.state = {
          Modal: null,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    return _this;
  }
  /**
   * 「戻る」ボタン押下時の処理を行います。
   */


  _createClass(SessionStreamingSettingModalComponent, [{
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#StreamingSettingDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * 配信URLをクリップボードにコピーします。
     */

  }, {
    key: "copyToClilpboard",
    value: function copyToClilpboard() {
      var _this3 = this;

      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return navigator.clipboard.writeText(_this3.props.streamingUrl);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
    /**
     * ステータス名を取得します。
     *
     * @param status ステータス
     */

  }, {
    key: "getStreamingStatusName",
    value: function getStreamingStatusName(status) {
      switch (status) {
        case StreamingStatuses.Offline:
        case StreamingStatuses.Archive:
          return intl.format(StreamingSituations.Offline);

        case StreamingStatuses.Live:
          return intl.format(StreamingSituations.Live);

        default:
          return "";
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "StreamingSettingDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_360streaming_grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Streaming.SettingTitle))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-11 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label textalign-right",
        htmlFor: "StreamingLocation"
      }, intl.format(Label.StreamingLocation), " :"), /*#__PURE__*/React.createElement("label", {
        className: "col-7 col-form-label"
      }, this.props.streamingLocation.split('.').slice(0, -1).join('.')), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label textalign-center"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label textalign-right",
        htmlFor: "StreamingStatus"
      }, intl.format(Label.StreamingStatus), " :"), /*#__PURE__*/React.createElement("label", {
        className: "col-7 col-form-label"
      }, this.getStreamingStatusName(this.props.streamingStatus)), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label textalign-center"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label textalign-right",
        htmlFor: "StreamingUrl"
      }, intl.format(Label.StreamingUrl), " :"), /*#__PURE__*/React.createElement("label", {
        className: "col-7 col-form-label text-wrap"
      }, this.props.streamingUrl), /*#__PURE__*/React.createElement("div", {
        className: "col-3 col-form-label textalign-center"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "state_link",
        onClick: this.copyToClilpboard.bind(this),
        title: intl.format(Streaming.CopyUrl)
      }, intl.format(Streaming.CopyUrl))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))))));
    }
  }]);

  return SessionStreamingSettingModalComponent;
}(React.Component);

export { SessionStreamingSettingModalComponent as default };